const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const getCampaignFlyerInfo = queryVars => {
  const query = `query CampaignFlyerInfo($campaignId: ID) {
      campaignFlyerInfo(campaignId: $campaignId) {
        s3Link
        flyerName
        isFlyerUploaded
        activeRoomId
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}
